import React, { Component } from 'react';

export default class RoomsHeader extends Component {
  render() {
    const { firstName, surname, room, onRoomLeave } = this.props;

    return (
      <div>
        <h1 className="rooms-title">Witaj {firstName} {surname}</h1>
        {
          room ?
          <p className="rooms-subtitle">
            Jesteś zapisany do pokoju <span>{room.roomName}</span>.
            <button
              className="rooms-btn--delete"
              onClick={onRoomLeave}
            >Wypisz się</button>
          </p>
          :
          <p className="rooms-subtitle">Nie jesteś zapisany do pokoju.</p>

        }
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/modules/User/components/RoomsHeader.js